import { render, staticRenderFns } from "./PIC.vue?vue&type=template&id=631b7602&scoped=true"
import script from "./PIC.vue?vue&type=script&lang=js"
export * from "./PIC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b7602",
  null
  
)

export default component.exports